import { action } from 'easy-peasy';
import { IActionSetHospitalSelectors } from '../types';

const setHospitalSelectors: IActionSetHospitalSelectors = action((state, payload) => {
  state.selectors = payload;
});

export default setHospitalSelectors;
